import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Row, Col } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";

import { find } from "lodash";
import moment from "moment";

import CallService from "../../services/callService";

import * as callActions from "../../actions/callActions";
import * as modalActions from "../../actions/modalActions";
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";
import * as projectActions from "../../actions/projectActions";
import * as departmentActions from "../../actions/departmentActions";
import * as codeActions from "../../actions/codeActions";

import CallList from "./CallList";
import HeaderWrapper from "../common/HeaderWrapper";
import FiltersComponent from "../common/FiltersComponent";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

/* Both calendar and table view are making paginated/filtered queries 
to ensure you're only loading the calls you need */

class CallPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredUsers: [],
      filteredProjects: [],
      calls: [],
      open: true,
      focusedInput: null,
      deleteRecurring: false,
      defaultPageSize: localStorage.getItem("DEFAULT_PAGE_SIZE_CALL_LIST")
        ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_CALL_LIST"))
        : 10,
      list: localStorage.getItem("list")
        ? JSON.parse(localStorage.getItem("list"))
        : true,
      filters: localStorage.getItem("filters")
        ? JSON.parse(localStorage.getItem("filters"))
        : {
            customer: [],
            project: [],
            stage: [],
            department: [],
            call_type: [],
            multi_assigned_to: props.auth?.user
              ? [
                  {
                    label: props.auth.user.full_name,
                    value: props.auth.user.id
                  }
                ]
              : [],
            arrival_date: null,
            completed_date: null,
            workplace: [],
            priority: []
          }
    };
  }

  componentDidMount = () => {
    const { customers, projects, departments, users, allUsers, actions } =
      this.props;

    if (!projects.length) actions.loadProjects();

    if (!customers.length) actions.loadCustomers();
    if (!departments.length) actions.loadDepartments();

    if (!users.length) actions.loadUsers();
    if (!allUsers.length) actions.loadAllUsers();

    this.setState({
      filteredProjects: this.props.projects,
      filteredUsers: this.props.users,
      accurateTotals: false,
      fetchingTotals: false
    });
  };

  onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_CALL_LIST", pageSize);
  };

  onClickView = (id) => {
    this.props.history.push(`/app/calls/${id}`);
  };

  onClickDelete = (id, isRecurring) => {
    this.props.actions.requestCallId(id);
    this.setState({ deleteRecurring: isRecurring });
  };

  onClickToggle = () => {
    this.setState({ list: !this.state.list }, () =>
      localStorage.setItem("list", this.state.list)
    );
  };

  fetchCalls = async (state) => {
    const queryState = {
      ...state,
      filtered: {
        ...state.filtered,
        arrival_date: [
          state.filtered.arrival_date,
          state.filtered.completed_date
        ],
        completed_date: null
      }
    };
    const { calls, pages, total } = await CallService.loadCalls(queryState);
    this.setState({ calls, pages, total });
  };

  calculateTotals = async () => {
    this.setState({ fetchingTotals: true });
    const filtered = { ...this.state.filters };
    const totalHours = true;
    const { billable_hrs, actual_hrs } = await CallService.loadCalls({
      filtered,
      totalHours
    });

    this.setState({
      billable_hrs,
      actual_hrs,
      accurateTotals: true,
      fetchingTotals: false
    });
  };

  handleSelect = (call) => {
    this.props.history.push(`/app/calls/${call._id}`);
  };

  handleDelete = async () => {
    await this.props.actions.deleteCall(this.props.callToDelete);
    await this.reload();
  };

  confirmDelSingle = async () => {
    await this.props.actions.deleteCall(this.props.callToDelete);
    await this.props.actions.hideModal();
    await this.reload();
  };

  confirmDelSeries = async () => {
    const callToDelete = find(this.state.calls, {
      _id: this.props.callToDelete
    });
    await this.props.actions.deleteRecurringCalls(callToDelete.recurring_id);
    await this.props.actions.hideModal();
    await this.reload();
    await this.setState({ deleteRecurring: false });
  };

  handleChangeFilters = async (field, value) => {
    const filters = { ...this.state.filters };
    filters[field] = value;
    if (field === "department") {
      // get department users for multi_assigned_to options
      const users = [];
      for (let i = 0; i < value.length; i += 1) {
        this.props.users.forEach((user) => {
          if (user.department._id === value[i].value) {
            users.push(user);
          }
        });
      }
      this.setState({ filteredUsers: users });
    }

    if (field === "multi_assigned_to") {
      // get user departments for assigned_department filter
      const userIds = value.map((val) => val.value);
      const users = this.props.users.filter((user) =>
        userIds.includes(user._id)
      );
      const departmentIds = users.map((user) => user.department._id);
      const departmentFilters = this.props.departments
        .filter((department) => departmentIds.includes(department._id))
        .map((department) => ({
          value: department._id,
          label: department.description
        }));
      filters.multi_assigned_to = value;
      filters.department = departmentFilters;
    }

    if (field === "customer") {
      // get customer projects for project options
      const projects = [];
      for (let i = 0; i < value.length; i += 1) {
        this.props.projects.forEach((project) => {
          if (project.customer && project.customer._id === value[i].value) {
            projects.push(project);
          }
        });
      }
      this.setState({ filteredProjects: projects });
    }

    if (field === "project") {
      // find the selected project(s) from props to get their customer._id and use it to populate the customer filter.
      const projectIds = value.map((val) => val.value);
      const projects = this.props.projects.filter((project) =>
        projectIds.includes(project._id)
      );
      const customerIds = projects.map((project) => project.customer._id);
      const customerFilters = this.props.customers
        .filter((customer) => customerIds.includes(customer._id))
        .map((customer) => ({
          value: customer._id,
          label: customer.name
        }));
      filters.customer = customerFilters;
    }

    this.setState({ filters: { ...filters }, accurateTotals: false }, () => {
      localStorage.setItem("filters", JSON.stringify(filters));
    });
  };

  handleChangeDate = (startDate, endDate) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          ...(startDate && { arrival_date: moment(startDate).startOf("day") }),
          ...(endDate && { completed_date: moment(endDate).endOf("day") })
        },
        accurateTotals: false
      },
      () => {
        localStorage.setItem("filters", JSON.stringify(this.state.filters));
      }
    );
  };

  resetFilters = () => {
    this.setState({
      filters: {
        customer: [],
        project: [],
        multi_assigned_to: [],
        stage: [],
        call_type: [],
        department: [],
        arrival_date: null,
        completed_date: null,
        workplace: [],
        priority: []
      },
      filteredUsers: this.props.users,
      filteredProjects: this.props.projects,
      accurateTotals: false
    });

    localStorage.removeItem("filters");
  };

  render() {
    const { customers, projects, users, allUsers, codes, isMobile } =
      this.props;
    const {
      calls,
      pages,
      deleteRecurring,
      defaultPageSize,
      total,
      accurateTotals,
      fetchingTotals,
      billable_hrs,
      actual_hrs
    } = this.state;

    const actions = (
      <span>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSingle}
        >
          Delete Single
        </button>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSeries}
        >
          Delete Series
        </button>
      </span>
    );

    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: `Call Lookup (${total || 0} calls)` }]}
          onClickAdd={() => this.props.history.push(`/app/calls/add`)}
          onClickAction={[
            {
              action: () => this.setState({ open: !this.state.open }),
              icon: <IoFunnel />
            }
            // hidden for now since time planner is more robust
            // {
            //   action: this.onClickToggle,
            //   icon: this.state.list ? faCalendarAlt : faListUl
            // }
          ]}
          isMobile={isMobile}
        />
        <Row ref={(r) => (this.row = r)}>
          <Col md={12} xs={12}>
            <FiltersComponent
              filteredUsers={
                this.state.filters.department &&
                this.state.filters.department.length
                  ? allUsers.filter(
                      (user) =>
                        user.department &&
                        this.state.filters.department.some(
                          (dept) => dept.value === user.department._id
                        )
                    )
                  : allUsers
              }
              filteredProjects={
                this.state.filters.customer &&
                this.state.filters.customer.length
                  ? projects.filter(
                      (proj) =>
                        proj.customer &&
                        this.state.filters.customer.some(
                          (cust) => cust.value === proj.customer._id
                        )
                    )
                  : []
              }
              open={this.state.open}
              filters={this.state.filters}
              focusedInput={this.state.focusedInput}
              onChangeFilters={this.handleChangeFilters}
              onChangeDate={this.handleChangeDate}
              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
              onReset={this.resetFilters}
              fields={[
                "Customer",
                "Multi Project",
                "Status",
                "Date",
                "Department",
                "Multi Assigned To",
                "Call Type",
                "Workplace",
                "Priority"
              ]}
            />
          </Col>
        </Row>
        <Row>
          <div>
            {accurateTotals && (
              <React.Fragment>
                <span style={{ marginRight: "20px", marginLeft: "20px" }}>
                  Billable Hours: {billable_hrs}
                </span>
                <span style={{ marginRight: "20px" }}>
                  Actual Hours: {actual_hrs}
                </span>
              </React.Fragment>
            )}
            {total < 1000 && (
              <span
                className="pull-right form-action"
                onKeyDown={() => {}}
                role="presentation"
                onClick={fetchingTotals ? null : this.calculateTotals}
                style={{
                  color: "#50accb",
                  float: "right",
                  marginRight: "20px",
                  cursor: "pointer"
                }}
              >
                {fetchingTotals ? "CALCULATING..." : "CALCULATE TOTALS"}
              </span>
            )}
          </div>
        </Row>

        <div className="content-wrapper">
          <CallList
            ticketRedirect
            data={calls}
            users={allUsers}
            pages={pages}
            projects={projects}
            fetchData={this.fetchCalls}
            reloadData={(r) => (this.reload = r)}
            isMobile={isMobile}
            serverSide
            filtered={this.state.filters}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            defaultPageSize={defaultPageSize}
            onPageSizeChange={this.onPageSizeChange}
          />
        </div>
        <Modal
          id="callDetailsModal"
          title="Call Info"
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="callConfirmModal"
          title={
            deleteRecurring
              ? `This call is part of a recurring series`
              : `Delete Call`
          }
          body={
            deleteRecurring
              ? `Do you want to delete this series or this single call?`
              : `Are you sure you want to delete this call?`
          }
          actions={deleteRecurring ? actions : ""}
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </React.Fragment>
    );
  }
}

CallPage.propTypes = {
  actions: PropTypes.object,
  auth: PropTypes.object,
  callToDelete: PropTypes.string,
  customers: PropTypes.array,
  codes: PropTypes.array,
  users: PropTypes.array,
  allUsers: PropTypes.array,
  projects: PropTypes.array,
  isMobile: PropTypes.bool,
  departments: PropTypes.array,
  history: PropTypes.object
};

CallPage.defaultProps = {};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    callToDelete: state.reducers.callToDelete,
    customers: state.reducers.customers,
    users: state.reducers.users,
    allUsers: state.reducers.allUsers,
    projects: state.reducers.projects,
    departments: state.reducers.departments,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...callActions,
        ...codeActions,
        ...userActions,
        ...departmentActions,
        ...projectActions,
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallPage);
